import {gql} from '@apollo/client';
export const BUY_DESIGN = gql`
    mutation buyDesign($designId: ID!){
        buyDesign(designId: $designId){
            url
        }
    }
`